module.exports = __webpack_public_path__ + "img/9788984316713.d43cf81b.jpg";